import {
  ColumnDef,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { TableCell, Avatar, ActionButton } from '@maia/ui';
import { IconSearchAlt } from '@maia/icons';
import { DrawerStore, useDrawerStore } from './../../../stores/drawer.store';
import { NoteDto } from '@maia/shared';
import { PaginationDto } from '@maia/pagination';

type TableMeta = {
  openDrawer: DrawerStore['openDrawer'];
};

const columns: ColumnDef<NoteDto>[] = [
  {
    accessorKey: 'guid',
    header: 'Inhoud',
    enableSorting: false,
    cell: ({ row }) => (
      <TableCell.NoteContent
        icon={row.original.icon}
        title={row.original.title}
        content={row.original.content}
      />
    ),
  },
  {
    accessorKey: 'createdAt',
    header: 'Aanmaakdatum',
    enableSorting: false,
    cell: ({ row }) => <TableCell.Date date={row.original.createdAt} />,
  },
  {
    accessorKey: '',
    header: 'Door',
    enableSorting: false,
    cell: ({ row }) => <Avatar initials={row.original.createdBy.initials} />,
  },
  {
    id: 'actions',
    cell: ({ table, row }) => (
      <div className="flex gap-x-12 items-center place-content-end w-full">
        <ActionButton
          icon={IconSearchAlt}
          size="small"
          onPress={() =>
            (table.options.meta as TableMeta).openDrawer({
              type: 'note',
              data: row.original,
            })
          }
        />
      </div>
    ),
  },
];

export function useNoteTable(
  notes: Array<NoteDto> = [],
  pagintaion?: PaginationDto,
) {
  const { openDrawer } = useDrawerStore();

  return useReactTable({
    columns,
    data: notes,
    rowCount: notes?.length ?? 0,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    pageCount: pagintaion?.totalPages ?? 0,
    meta: {
      openDrawer,
    },
  });
}
